export const orderCloudProduct = {
  name: 'OrderCloud',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Simplify commerce for your complex requirements ​and deliver personalized experiences anywhere.​​',
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/e496fb48ca514bb2a06a48e7337b68d9',
  },
  color: 'teal',
  baseUrl: {
    dev: 'https://ordercloud-dev.sitecore-staging.cloud',
    qa: 'https://portal.ordercloud-qa.com/sitecore-auth',
    staging: 'https://ordercloud-staging.sitecore-staging.cloud',
    'pre-production': 'https://ordercloud-staging.sitecore-staging.cloud',
    production: 'https://ordercloud.sitecorecloud.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}?organization={organizationId}&tenantName={tenantName}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
      {
        key: 'tenantName',
        source: {
          resource: 'tenant',
          jsonPath: '$.name',
        },
      },
    ],
  },
};
